//引入外部模組
import hcSticky from 'hc-sticky';




class Sticky {
  constructor() {
    this.el = '#stickyBox';
  }
  move() {
    let sticky = new hcSticky(this.el, {
      top: 60
    });
  }
}




//輸出
export {Sticky};


// WEBPACK FOOTER //
// ./js_new/sticky.js